<div class="leads-top-bar px-5 py-4">
  <div class="row align-items-center">
    <div class="col text-right">
      <button (click)="addTask()" class="px-3" nz-button nzType="primary" nzSize="default" nzShape="round">
        Новое задание
        <i-feather name="plus-circle" class="ml-2"></i-feather>
      </button>
    </div>
    <div class="col-auto ">
      <small tooltip="Ваш ID, сообщите при обращении&nbsp;в&nbsp;поддержку" class="text-muted mr-3 align-middle d-none d-md-inline">#{{(senderService.account$ | async)?.id}}</small>
    </div>
    <div class="col-auto">
      <i-feather tooltip="В разработке" name="question" class="ml-2 normal autosize"></i-feather>
      <i-feather (click)="addTask()" name="profile" class="ml-4 normal autosize"></i-feather>
    </div>
  </div>
</div>
